import styles from "./Overlay.module.css"

const Overlay=(props)=>{
    return(
        <div className={`${styles.overlay} ${props.className}`}>{props.children}</div>
    )
}

export default Overlay